"use strict";

function getOriginalCounterPart(index, _a, childrenArr) {
  var slidesToShow = _a.slidesToShow,
      currentSlide = _a.currentSlide;
  return childrenArr.length > 2 * slidesToShow ? index + 2 * slidesToShow : currentSlide >= childrenArr.length ? childrenArr.length + index : index;
}

function getOriginalIndexLookupTableByClones(slidesToShow, childrenArr) {
  if (childrenArr.length > 2 * slidesToShow) {
    for (var table = {}, firstBeginningOfClones = childrenArr.length - 2 * slidesToShow, firstEndOfClones = childrenArr.length - firstBeginningOfClones, firstCount = firstBeginningOfClones, i = 0; i < firstEndOfClones; i++) {
      table[i] = firstCount, firstCount++;
    }

    var secondBeginningOfClones = childrenArr.length + firstEndOfClones,
        secondEndOfClones = secondBeginningOfClones + childrenArr.slice(0, 2 * slidesToShow).length,
        secondCount = 0;

    for (i = secondBeginningOfClones; i <= secondEndOfClones; i++) {
      table[i] = secondCount, secondCount++;
    }

    var originalEnd = secondBeginningOfClones,
        originalCounter = 0;

    for (i = firstEndOfClones; i < originalEnd; i++) {
      table[i] = originalCounter, originalCounter++;
    }

    return table;
  }

  table = {};
  var totalSlides = 3 * childrenArr.length,
      count = 0;

  for (i = 0; i < totalSlides; i++) {
    table[i] = count, ++count === childrenArr.length && (count = 0);
  }

  return table;
}

function getClones(slidesToShow, childrenArr) {
  return childrenArr.length < slidesToShow ? childrenArr : childrenArr.length > 2 * slidesToShow ? childrenArr.slice(childrenArr.length - 2 * slidesToShow, childrenArr.length).concat(childrenArr, childrenArr.slice(0, 2 * slidesToShow)) : childrenArr.concat(childrenArr, childrenArr);
}

function getInitialSlideInInfiniteMode(slidesToShow, childrenArr) {
  return childrenArr.length > 2 * slidesToShow ? 2 * slidesToShow : childrenArr.length;
}

function checkClonesPosition(_a, childrenArr, props) {
  var isReachingTheEnd,
      currentSlide = _a.currentSlide,
      slidesToShow = _a.slidesToShow,
      itemWidth = _a.itemWidth,
      totalItems = _a.totalItems,
      nextSlide = 0,
      nextPosition = 0,
      isReachingTheStart = 0 === currentSlide,
      originalFirstSlide = childrenArr.length - (childrenArr.length - 2 * slidesToShow);
  return childrenArr.length < slidesToShow ? (nextPosition = nextSlide = 0, isReachingTheStart = isReachingTheEnd = !1) : childrenArr.length > 2 * slidesToShow ? ((isReachingTheEnd = currentSlide >= originalFirstSlide + childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = -itemWidth * (nextSlide = originalFirstSlide + (childrenArr.length - 2 * slidesToShow)))) : ((isReachingTheEnd = currentSlide >= 2 * childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = props.showDots ? -itemWidth * (nextSlide = childrenArr.length) : -itemWidth * (nextSlide = totalItems - 2 * slidesToShow))), {
    isReachingTheEnd: isReachingTheEnd,
    isReachingTheStart: isReachingTheStart,
    nextSlide: nextSlide,
    nextPosition: nextPosition
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getOriginalCounterPart = getOriginalCounterPart, exports.getOriginalIndexLookupTableByClones = getOriginalIndexLookupTableByClones, exports.getClones = getClones, exports.getInitialSlideInInfiniteMode = getInitialSlideInInfiniteMode, exports.checkClonesPosition = checkClonesPosition;